import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Slider from '@mui/material/Slider';

// Styles is imported in app/styles/index.js

export default class FormRangeSlider extends Component {
  static propTypes = {
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      value: [
        (props.defaultValue && props.defaultValue.min) || props.min,
        (props.defaultValue && props.defaultValue.max) || props.max
      ]
    };
  }

  toRangeObject = (value) => ({
    min: value[0],
    max: value[1]
  });

  handleIntermediateChange = (event, value) => {
    this.setState({ value });
  };

  handleChange = (event, value) => {
    const rangeValue = this.toRangeObject(value);

    // Simulated event
    const ev = {
      target: {
        name: this.props.name,
        value: rangeValue,
        type: 'range'
      }
    };

    this.props.onChange(ev);
    this.setState({ value });
  };

  render() {
    const { value } = this.state;
    const {
      label, // eslint-disable-line no-unused-vars
      min,
      max,
      defaultValue, // eslint-disable-line no-unused-vars
      onChange, // eslint-disable-line no-unused-vars
      ...props
    } = this.props;

    return (
      <Slider
        min={min}
        max={max}
        {...props}
        value={value}
        onChange={this.handleIntermediateChange}
        onChangeCommitted={this.handleChange}
        valueLabelDisplay="auto"
      />
    );
  }
}